import { Collection } from 'modules/core/lib/mobx-rest'

import ClockPicture from 'modules/employees/store/models/ClockPicture'

export class ClockPictures extends Collection<ClockPicture> {
  get indexes() {
    return ['employee_id']
  }

  model() {
    return ClockPicture
  }
}
